import React from 'react';
import { useTranslation } from 'react-i18next';

import Custom from 'component/Layout/Form/Select/Custom';

import { QaIdentifier, useQa } from 'hooks/useQa';

import { SortOrder } from 'types/Search/form';

import { SortOption } from './types';

import styles from './List.module.scss';

export interface ListProps {
    optionList: SortOption[];
    current: SortOrder;
    onSelect: (value: SortOrder) => void;
}

const List = ({ optionList, current, onSelect }: ListProps) => {
    const { t } = useTranslation();
    const qaAttr = useQa(QaIdentifier.Search_Sort_List);

    return (
        <div className={styles.Wrapper} {...qaAttr}>
            {t('TRANS-sort')}:
            <Custom
                onClick={onSelect}
                currentValue={current}
                optionList={optionList}
                customClass={{
                    SelectWrapper: styles.SelectWrapper,
                    Select: styles.Select,
                    Dropdown: styles.Dropdown,
                    Option: styles.Option,
                    Selected: styles.Selected,
                }}
            />
        </div>
    );
};

export default List;
